import React, {useEffect, useRef, useState} from 'react';
import {
    LeftMenuWrapper,
    LeftSideBarWrapper,
    LeftMenuItem,
    LeftMenuText,
    LeftMenuIcon,
    HelpBox,
    HelpImage,
} from '../Components/StyledComponents';
import {useDispatch, useSelector} from 'react-redux';
import ModalDialog from '../Components/ModalDialog';
import ResizePanel from './SubPanels/ResizePanel';
import AddtionalElementsContets from '../Components/ModalContents/AdditionalElementsModalContent';
import SwapTemplateContent from '../Components/ModalContents/SwapTemplateContent';
import EditBackground from '../Components/ModalContents/EditBackground';
import HelpModalContent from '../Components/ModalContents/HelpModalContent';
import {EditImageIcon, ElementsIcon, QRCodeIcon, ResizeIcon} from "../assets/icons";
import {setPanelKey} from "../store/reducers/panleKey";
import FontFamilyPanel from "./SubPanels/FontFamily";
import ImageTabs from "./SubPanels/ImagesTabs";
import QRCodeScanner from "./SubPanels/QRCode";
import {ColorPicker} from "./SubPanels/ColorPickerPanel";
import {setBackgroundState} from "../store/reducers/modalToggler";
import AssetsTabs from "./SubPanels/AssetsTabs";
import TextTabs from "./SubPanels/TextTabs";

const LeftSideBar = ({resizeCanvas, toggleSubMenu, setToggleSubMenu, stopEvents, initEvents}) => {

    const panelKey = useSelector((state) => state.panelKey).panelKey;
    const {triggerColorPallet} = useSelector((state) => state.colorSlice);

    const [openElementsModal, setOpenElementsModal] = useState(false);
    const [openBackgroundModal, setOpenBackgroundModal] = useState(false);
    const [openSwapTemplateModal, setOpenSwapTemplateModal] = useState(false);
    const [helpActive, setHelpActive] = useState(false);

    const dispatch = useDispatch()
    const scrollRef = useRef()

    useEffect(()=>{
        scrollRef.current.scrollTo(0, 0);
        dispatch(setBackgroundState(false))
    },[panelKey,triggerColorPallet])

    const CloseElementsModal = () => {

        setOpenElementsModal(false);
    }
    const CloseBackgroundModal = () => {
        setOpenBackgroundModal(false);
    }
    const CloseSwapTemplateModal = () => {
        setOpenSwapTemplateModal(false);
    }

    const CloseHelpActiveModal = () => {
        setHelpActive(false);
    }

    const toggleOpen = (key) => {
        if (key === panelKey && toggleSubMenu) {
            setToggleSubMenu(false);
        } else {
            setToggleSubMenu(true);
            dispatch(setPanelKey(key))
        }
    };

    return (
        <>
            <LeftSideBarWrapper>
                <LeftMenuWrapper>
                    <LeftMenuItem className={`step-1 ${panelKey === '1' ? 'toolbar_active_menu' : ''}`} onClick={() => toggleOpen('1')}>
                        <LeftMenuIcon src='/images/AddText.png'/>
                        <LeftMenuText>Add Text</LeftMenuText>
                    </LeftMenuItem>
                    <LeftMenuItem className={`step-2 ${panelKey === '2' ? 'toolbar_active_menu' : ''}`} onClick={() => toggleOpen('2')}>
                        <EditImageIcon/>
                        <LeftMenuText>Images</LeftMenuText>
                    </LeftMenuItem>
                    <LeftMenuItem className={`step-3 ${panelKey === '3' ? 'toolbar_active_menu' : ''}`} onClick={() => toggleOpen('3')}>
                        <ResizeIcon/>
                        <LeftMenuText>Resize</LeftMenuText>
                    </LeftMenuItem>
                    <LeftMenuItem className={`step-4 ${panelKey === '4' ? 'toolbar_active_menu' : ''}`} onClick={() => toggleOpen('4')}>
                        <ElementsIcon/>
                        <LeftMenuText>Assets</LeftMenuText>
                    </LeftMenuItem>
                    {/*<LeftMenuItem className={panelKey === '4' ? 'toolbar_active_menu' : ''} onClick={() => setOpenSwapTemplateModal(true)}>*/}
                    {/*    <VscArrowSwap size="30px" color="#38485D"/>*/}
                    {/*    <LeftMenuText>Swape Template</LeftMenuText>*/}
                    {/*</LeftMenuItem>*/}
                    <LeftMenuItem style={{paddingTop: '5px'}} className={`fourth-step ${panelKey === '5' ? 'toolbar_active_menu' : ''}`} onClick={() => toggleOpen('5')}>
                        <QRCodeIcon/>
                        <LeftMenuText>Generate QR code</LeftMenuText>
                    </LeftMenuItem>
                </LeftMenuWrapper>
                <HelpBox className={`step-5 ${panelKey === '7' ? 'toolbar_active_menu' : ''}`} isActive={helpActive} onClick={() => toggleOpen('7')}>
                    <HelpImage src="/images/LeftMenu-Bottom.png"/>
                    <LeftMenuText>AI writer</LeftMenuText>
                </HelpBox>
            </LeftSideBarWrapper>
            <div ref={scrollRef} className={`toolbar_sub_menu ${toggleSubMenu ? 'menu-w-300' : 'menu-w-0'}`}>
                {
                    panelKey === '1' && <TextTabs setToggleSubMenu={setToggleSubMenu}/>
                }
                {
                    panelKey === '2' && <ImageTabs setToggleSubMenu={setToggleSubMenu} stopEvents={stopEvents} initEvents={initEvents}/>
                }
                {
                    panelKey === '3' && <ResizePanel setToggleSubMenu={setToggleSubMenu} resizeCanvas={resizeCanvas}/>
                }
                {
                    panelKey === '4' && <AssetsTabs />
                }
                {
                    panelKey === '5' && <QRCodeScanner setToggleSubMenu={setToggleSubMenu}/>
                }
                {
                    panelKey === '7' && <HelpModalContent />
                }
                {
                    panelKey === 'fontFamily' && <FontFamilyPanel />
                }
                {
                    panelKey === 'colorPicker' && <ColorPicker />
                }
            </div>
            <ModalDialog
                OpenModal={openElementsModal}
                CloseModal={CloseElementsModal}
                title="Add Additional Elements"
                size="md"
                ModalContent={<AddtionalElementsContets/>}
                defaultScroll={false}
            />
            <ModalDialog
                OpenModal={openBackgroundModal}
                CloseModal={CloseBackgroundModal}
                title="Select your background"
                size="sm"
                ModalContent={<EditBackground/>}
                defaultScroll={true}
            />
            <ModalDialog
                OpenModal={openSwapTemplateModal}
                CloseModal={CloseSwapTemplateModal}
                title=""
                size="md"
                ModalContent={<SwapTemplateContent setOpenSwapTemplateModal={setOpenSwapTemplateModal} resizeCanvas={resizeCanvas}/>}
                defaultScroll={true}
                titlePadding={false}
            />
            <ModalDialog
                OpenModal={helpActive}
                CloseModal={CloseHelpActiveModal}
                helpModal={true}
                size="sm"
                ModalContent={<HelpModalContent/>}
                defaultScroll={true}
                titlePadding={true}
            />
        </>
    );
}

export default LeftSideBar;
